/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AccessKeysContext } from "../context/AccessKeysContext"
import "./styles/styles.css"
import clsx from "clsx"
import React, { Component } from "react"
import { Col, Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"

export default class TextField extends Component {
  render() {
    return (
      <AccessKeysContext.Consumer>
        {(accessKeys = {}) => {
          const { name, role } = this.props
          const ak = accessKeys[name] || {}
          const {
            hidden,
            placeholder,
            inputmode,
            label,
            className,
            xs,
            lg,
            xl,
            md,
            sm,
            xsHidden,
            smHidden,
            mdHidden,
            lgHidden,
            xlHidden,
            disabled,
            hasServerErrors,
            noFormGroup,
            formGroupProps,
            initialValue,
            type = "text",
            trimOnBlur,
            formatOnBlur,
            addCbSeparator,
            addIbanSeparator,
            onChange,
            maj,
            style,
            children
          } = { ...this.props, ...ak }

          if (hidden) {
            return false
          }
          let trimOnBlurProps = null
          if (trimOnBlur === true) {
            trimOnBlurProps = {
              formatOnBlur: true,
              format: this.trimValue
            }
          }
          let formatOnBlurProps = null
          if (formatOnBlur === true) {
            formatOnBlurProps = {
              formatOnBlur: true,
              format: (value) => this.formatValueOnBlur(value, addIbanSeparator)
            }
          }
          let addCbSeparatorProps = null
          if (addCbSeparator === true) {
            addCbSeparatorProps = {
              onKeyUp: this.addCbSeparator
            }
          }

          return (
            <FinalFormField
              name={name}
              component="input"
              type={type}
              placeholder={placeholder}
              className="form-control"
              initialValue={initialValue}
              {...trimOnBlurProps}
              {...formatOnBlurProps}
            >
              {({ input, meta }) => {
                const metaError = meta.error && (meta.touched || hasServerErrors)
                const hasError = metaError || meta.submitError
                const cl = {
                  "d-none": xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
                  "d-sm-block": !smHidden,
                  "d-sm-none": smHidden,
                  "d-md-block": !mdHidden,
                  "d-md-none": mdHidden,
                  "d-lg-block": !lgHidden,
                  "d-lg-none": lgHidden,
                  "d-xl-block": !xlHidden,
                  "d-xl-none": xlHidden,
                  "col-no-padding": true
                }
                if (className) {
                  cl[className] = true
                }
                const hasColParam =
                  xs || lg || xl || md || sm || xsHidden || smHidden || mdHidden || lgHidden || xlHidden
                const colParams = { className: cl, xs, lg, xl, md, sm }

                let body = [
                  <div className="d-flex" key={label}>
                    {label && <Form.Label>{label}</Form.Label>}
                    {children}
                  </div>,
                  <Form.Control
                    id={name}
                    key="input"
                    role={role}
                    autoComplete="off"
                    inputMode={inputmode ? inputmode : null}
                    {...input}
                    onChange={(event) => {
                      if (initialValue) input.onChange(initialValue)
                      if (onChange) {
                        onChange(event.target.value)
                      }
                      input.onChange(event.target.value)
                    }}
                    // in case the input value is a select element we don't display [object object]
                    value={input.value.value ? "" : input.value}
                    className={clsx(hasError && "textfield-error", maj && "maj-text")}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...addCbSeparatorProps}
                  />,
                  <React.Fragment key="alert">
                    {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
                  </React.Fragment>
                ]

                if (!noFormGroup) {
                  body = (
                    <FormGroup style={style} {...formGroupProps}>
                      {body}
                    </FormGroup>
                  )
                }

                if (hasColParam) {
                  body = <Col {...colParams}>{body}</Col>
                }

                return body
              }}
            </FinalFormField>
          )
        }}
      </AccessKeysContext.Consumer>
    )
  }

  formatValueOnBlur(value, addIbanSeparator) {
    if (value === undefined) return ""
    if (value !== undefined) {
      let updatedValue = value
      if (addIbanSeparator) {
        updatedValue = updatedValue
          ?.toUpperCase()
          ?.replace(/\s/g, "")
          ?.replace(/(.{4})/g, "$1 ")
      }
      return updatedValue
    }
  }

  trimValue(value) {
    return value ? value?.trim() : null
  }

  addCbSeparator(event) {
    if (event.key !== "Backspace") {
      let formattedChain = event.currentTarget.value?.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")
      event.currentTarget.value = formattedChain
    }
  }
}
